const BLOCK = 'LStudio__app_form';

/*
    🔥 ESTRUCTURA DEL FORMULARIO

    Grilla de 2 columnas por defecto; cada campo declara cuántas ocupa
    con su prop `span`. En mobile todo colapsa a una sola columna sin
    que haya que tocar nada.

    ⚠️ Form usa <form> de verdad, así que el Enter envía y el navegador
       valida. onSubmit ya viene con preventDefault aplicado.
*/

export const Form = ({ onSubmit, columns = 2, children, ...rest }) => (

    <form className={BLOCK} data-columns={columns} noValidate
        onSubmit={(event) => { event.preventDefault(); if (onSubmit) onSubmit(event); }}
        {...rest} >
        {children}
    </form>
);

export const FormSection = ({ title, description, columns = null, children, className = '', ...rest }) => (

    <fieldset className={`${BLOCK}__section ${className}`.trim()} {...rest}>

        {title && <legend className={`${BLOCK}__section_title`}>{title}</legend>}

        {description && <p className={`${BLOCK}__section_desc`}>{description}</p>}

        <div className={`${BLOCK}__grid`} data-columns={columns ?? undefined}>{children}</div>

    </fieldset>
);

export const FormGrid = ({ columns = 2, children }) => (
    <div className={`${BLOCK}__grid`} data-columns={columns}>{children}</div>
);

export const FormActions = ({ align = 'end', children }) => (
    <div className={`${BLOCK}__actions`} data-align={align}>{children}</div>
);

/*
    🔥 BOTÓN DEL FORMULARIO

    No uso el de react-bootstrap a propósito: ese no lee --LS__tpl_*,
    así que el eje estético no lo alcanzaría.
*/
export const FormButton = ({ variant = 'primary', isLoading = false, children, ...rest }) => (

    <button className={`${BLOCK}__button`} data-variant={variant}
        disabled={isLoading || rest.disabled} {...rest} >
        {isLoading && <span className={`${BLOCK}__spinner`} aria-hidden="true" />}
        {children}
    </button>
);
